import r from"../../shared-lib/braze-shared-lib.js";export function setLogger(e){r.D.setLogger(e)}